import { render, staticRenderFns } from "./addDaHuo.vue?vue&type=template&id=2da1cc0b&scoped=true&"
import script from "./addDaHuo.vue?vue&type=script&lang=js&"
export * from "./addDaHuo.vue?vue&type=script&lang=js&"
import style0 from "./addDaHuo.vue?vue&type=style&index=0&id=2da1cc0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1cc0b",
  null
  
)

export default component.exports